/**
 * @generated SignedSource<<78fcf624e72951114bcc1062daeb7ebe>>
 * @relayHash 9bfb69b0836337bc41f9768061644e42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 33c214dc8b2a25ae8ad9dee3a259c27adf82255c1b2788be998b95b158f1fab5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentLandingQuery } from './srcVirtualAgentLandingQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentLandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "33c214dc8b2a25ae8ad9dee3a259c27adf82255c1b2788be998b95b158f1fab5",
    "metadata": {},
    "name": "srcVirtualAgentLandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
